<template>
  <div>
    <el-dialog :title="'临时发货申请管理[' + detailsInfo.Apply_SN+']'" :close-on-click-modal="isclose" :visible.sync="dialogVisible"
      width="1200px" :before-close="handleClose">
      <div class="details-box">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">订单号 ：</div>
              <div>  <span class="links" @click="goOrderdetail(detailsInfo.Apply_OrdersID)">{{ orderssn }}</span></div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item"> 
              <div class="hw-form-item-label">配送省市：</div>
              <div class="is-status-text">{{ addressStr }}</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">配送地址 ：</div>
              <div>{{ detailsInfo.Apply_Address }}</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">收货人：</div>
              <div>{{ detailsInfo.Apply_Accepter }}</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">收货人电话 ：</div>
              <div>{{ detailsInfo.Apply_PhoneNumber }}</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">收货人手机：</div>
              <div>{{ detailsInfo.Apply_Mobile }}</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">总价 ：</div>
              <div>￥{{ Number(detailsInfo.Apply_TotalPrice).toFixed(2) }}</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">所有货物必须一次发货 ：</div>
              <div>{{ detailsInfo.Apply_IsAllReach==1?"是":"否" }}</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">申请状态：</div>
              <div>
                <span :class="judgeColor(Apply_ValidStatusStr)">{{ Apply_ValidStatusStr }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">审核状态：</div>
              <div>
                <span :class="judgeColor(Apply_StatusStr)">{{ Apply_StatusStr }}</span>
                <el-button type="primary"   v-if="detailsInfo.Apply_BPMBizObjectID"
                @click="searchBpm(detailsInfo.Apply_BPMBizObjectID)">查询审批情况</el-button>
              </div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">审核备注：</div>
              <div>
                {{ detailsInfo.Apply_AuditNote }}
              </div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">发货审批单：</div>
              <div>
                <span v-if="Orders_Delivery_ERPSN == '--'">--</span>
                <span class="hw-text-link" @click="getViewReceipt" v-else>点击查看</span>
              </div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="hw-form-item">
              <div class="hw-form-item-label">时间：</div>
              <div>{{ elformatDate(detailsInfo.Apply_Addtime, 'yyyy-MM-dd hh:mm:ss') }}</div>
            </div>
          </el-col>
        </el-row>
        <el-table :data="tableData" border style="width: 100%; margin-top: 20px"
          :header-cell-style="{ backgroundColor: '#F5F7FA' }">
          <el-table-column prop="No" show-overflow-tooltip label="箱号" align="center" width="120"></el-table-column>
          <!-- <el-table-column prop="Type" show-overflow-tooltip label="类型" align="center" width="80"></el-table-column> -->
          <el-table-column prop="ProductName" show-overflow-tooltip label="商品名称" align="left" width="350"></el-table-column>
          <el-table-column prop="Amount" label="发货数量" align="center" width="80"></el-table-column>
          <el-table-column label="备注" align="center" show-overflow-tooltip prop="Remarks"></el-table-column>
        </el-table>
        <el-table :data="tableData1" border style="width: 100%; margin-top: 20px"
          :header-cell-style="{ backgroundColor: '#F5F7FA' }">
          <el-table-column prop="Number" label="序号" align="center" width="50"></el-table-column>
          <el-table-column prop="ID" label="凭证ID" align="center" width="80"></el-table-column>
          <el-table-column prop="Receipt_BankName" show-overflow-tooltip label="汇入银行" align="center"></el-table-column>
          <el-table-column prop="Receipt_Type" label="凭证类型" align="center" width="80"></el-table-column>
          <el-table-column prop="Receipt_Code" show-overflow-tooltip label="汇款单位" align="center"></el-table-column>
          <el-table-column prop="Receipt_PayDate" label="付款日期" align="center" width="100"></el-table-column>
          <el-table-column prop="Receipt_Amount" label="汇款金额" align="center" width="100">
            <template slot-scope="scope">￥{{ Number(scope.row.Receipt_Amount).toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="Distribute_Amount" label="分配金额" align="center" width="100">
            <template slot-scope="scope">￥{{ Number(scope.row.Distribute_Amount).toFixed(2) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
        <el-button v-if="detailsInfo.Apply_Status == -2 && detailsInfo.Apply_ValidStatus == 1" type="primary"
          @click="onConfirm">提交</el-button>
        <el-button v-if="detailsInfo.Apply_Status == -2 && detailsInfo.Apply_ValidStatus == 1" @click="onCancel">取
          消</el-button>
        <el-button @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>

    <DispatchnoteDetails :isShowDialog="isShowDialog" :Orders_Delivery_ID="Orders_Delivery_ID" @handleClose="onClose" />
    <el-dialog :title="'临时发货申请管理' + detailsInfo.Apply_SN" :visible.sync="isSubmitDialog" width="60%" center
      :before-close="onSubmitDialogClose" :close-on-click-modal="false">
      <div class="details-box">
        <div class="details-box-title" v-if="appropriationrecord.length > 0">分款记录</div>
        <el-table :data="appropriationrecord" v-if="appropriationrecord.length > 0" border style="width: 100%; margin-top: 20px"
          :header-cell-style="{ backgroundColor: '#F5F7FA' }">
          <el-table-column prop="Receipt_ID" label="ID" align="center" width="80"></el-table-column>
          <el-table-column prop="Receipt_BandName" show-overflow-tooltip label="汇入银行" align="center"></el-table-column>
          <el-table-column prop="Receipt_Type" label="凭证类型" align="center" width="100"></el-table-column>
          <el-table-column prop="Receipt_Code" show-overflow-tooltip label="汇款单位" align="center"></el-table-column>
          <el-table-column prop="Receipt_PayDate" label="付款日期" align="center" width="100"></el-table-column>
          <el-table-column prop="Receipt_TotalAmount" label="汇款金额" align="center" width="100">
            <template slot-scope="scope">￥{{ Number(scope.row.Receipt_TotalAmount).toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="Receipt_Amount" label="分款金额" align="center" width="100">
            <template slot-scope="scope">￥{{ Number(scope.row.Receipt_Amount).toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="Receipt_ShowAmount" label="分配金额" align="center" width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.Receipt_ShowAmount" type="text" @input="
                scope.row.Receipt_ShowAmount = scope.row.Receipt_ShowAmount.replace(/[^0-9.]/g, '')
                  .replace(/(\..{2}).*/g, '$1')
                  .replace(/(\..*?)\..*/g, '$1')
                " clearable></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div class="details-box-title" style="margin-top: 20px">商品列表</div>
        <el-table :data="tableData" border style="width: 100%; margin-top: 20px"
          :header-cell-style="{ backgroundColor: '#F5F7FA' }">
          <el-table-column prop="No" label="箱号" show-overflow-tooltip align="center" width="100"></el-table-column>
          <!-- <el-table-column prop="Type" label="类型" align="center" width="100"></el-table-column> -->
          <el-table-column prop="ProductName" show-overflow-tooltip label="商品名称" align="left"></el-table-column>
          <el-table-column prop="Price" label="单价" align="center" width="100">
            <template slot-scope="scope">
              <span style="color: red">￥{{ Number(scope.row.Price).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Amount" label="发货数量" align="center" width="100"></el-table-column>
          <el-table-column prop="AmountPrice" label="合计" align="center" width="100">
            <template slot-scope="scope">
              <span style="color: red">￥{{ Number(scope.row.AmountPrice).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Receipt_Code" show-overflow-tooltip label="备注" align="center"></el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 20px">
          发货总额
          <span style="color: red">￥{{ totalPrice }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit">提交</el-button>
        <el-button @click="onSubmitDialogClose">返回</el-button>
      </span>
    </el-dialog>
    <BPMExamine :isSwitch="isSwitch" :id="detailsInfo.Apply_BPMBizObjectID" @setSwitchClose="setSwitchClose"
      v-if="isSwitch">
    </BPMExamine>
  </div>

</template>

<script>
import { getDisplayAddressStr } from '@/utils/utils.js'
import { formatDate } from '@/utils/utils.js'
import DispatchnoteDetails from '../components/DispatchnoteDetails.vue'
import BPMExamine from '@/components/BPMExamine';
export default {
  components: {
    DispatchnoteDetails,
    BPMExamine
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => false
    },
    id: {
      type: Number
    },
    orders: {
      type: String
    }
  },
  created() {
    this.orderssn = this.orders;
  },
  data() {
    return {
      isShowDialog: false,
      isSubmitDialog: false,
	  isclose:false,
      tableData: [],
      tableData1: [],
      appropriationrecord: [],
      isSwitch: false, // bpm审核弹窗
      orderssn: '',
      detailsInfo: {
        "Apply_Accepter": "",
        "Apply_Address": "",
        "Apply_Addtime": "",
        "Apply_AuditNote": "",
        "Apply_BPMBizObjectID": "",
        "Apply_City": "",
        "Apply_ControlDays": "",
        "Apply_Country": "",
        "Apply_County": "",
        "Apply_ID": '',
        "Apply_Mobile": "",
        "Apply_OrdersID": "",
        "Apply_PhoneNumber": "",
        "Apply_SN": "",
        "Apply_State": "",
        "Apply_Status": '',
        "Apply_TotalPrice": '',
        "Apply_ValidStatus": ''
      },
      Apply_ValidStatusStr: '',
      Apply_StatusStr: '',
      Orders_BPMAuditStatus: '',
      addressStr: '',
      Orders_Delivery_ERPSN: '',
      Orders_Delivery_ID: '',
      ischeck: true,
    }
  },
  watch: {
    dialogVisible(newval, oldval) {
      if (newval) {
        this.onInitData()
      }
    }
  },
  computed: {
    totalPrice() {
      let sum = 0
      this.tableData.map(item => {
        sum += Number(item.AmountPrice)
      })
      return sum.toFixed(2)
    },
  },
  methods: {
    //关闭弹窗
    handleClose() {
      this.$emit('handleClose', false)
    },
    onClose() {
      this.isShowDialog = false
    },     // 查看BPM审核
    searchBpm(e) {
      if (!this.detailsInfo.Apply_BPMBizObjectID) {
        this.$message.warning("业务对象ID不存在");
        return;
      }
      this.isSwitch = true;
    },
    setSwitchClose() {
      this.isSwitch = false;
    },
    //点击提交
    onConfirm() {
      this.$newsApi.getOrdersDeliveryApplyCheckBPMSendAudit({ Apply_ID: this.id }).then(res => {
        if (res.data.Resultcode == 0) {
          this.appropriationrecord = []

          this.appropriationrecord = res.data.data
          this.isSubmitDialog = true
          this.ischeck = true
        }
      })
    },
    //取消提交
    onCancel() {
      this.$confirm('确定要取消该临时发货申请吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$newsApi.getOrdersDeliveryApplyCancel({ Apply_ID: this.id, SourceType : "PC" }).then(res => {
          if (res.data.Resultcode == 0) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.onInitData()
          }
        })

      }).catch(() => {
      })
    },
    //初始化数据
    async onInitData() {
      this.isShowDialog = false
      this.tableData = []
      this.tableData1 = []
      this.Apply_ValidStatusStr = ''
      this.Apply_StatusStr = ''
      this.addressStr = ''
      this.Orders_Delivery_ERPSN = ''
      this.Orders_Delivery_ID = ''
      this.detailsInfo = {
        "Apply_Accepter": "",
        "Apply_Address": "",
        "Apply_Addtime": "",
        "Apply_AuditNote": "",
        "Apply_BPMBizObjectID": "",
        "Apply_City": "",
        "Apply_ControlDays": "",
        "Apply_Country": "",
        "Apply_County": "",
        "Apply_ID": '',
        "Apply_Mobile": "",
        "Apply_OrdersID": "",
        "Apply_PhoneNumber": "",
        "Apply_SN": "",
        "Apply_State": "",
        "Apply_Status": '',
        "Apply_TotalPrice": '',
        "Apply_ValidStatus": ''
      }
      this.getOrdersDeliveryApplyByID()
      this.getOrdersDeliveryApplyGoods()
      this.getOrdersDliveryApplyDistributet()
    },
    //点击查看发货单
    getViewReceipt() {
      this.isShowDialog = true
    },
    //获取详情信息
    getOrdersDeliveryApplyByID() {
      this.$newsApi.getOrdersDeliveryApplyByID({ Apply_ID: this.id }).then(res => {
        if (res.data.Resultcode == 0) {
          this.detailsInfo = res.data.data
          this.detailsInfo.Apply_Addtime = this.detailsInfo.Apply_Addtime
          this.getOrdersDeliveryApplyValidStatus()
          this.getOrdersBPMAuditStatus()
          this.getOrdersDeliveryByApplyID()
          this.getDisplayAddress()
          this.getOrdersByID(this.detailsInfo.Apply_OrdersID)
        }
      })
    },
    //获取付款列表
    getOrdersDliveryApplyDistributet() {
      this.$newsApi.getOrdersDliveryApplyDistributet({ Apply_ID: this.id }).then(res => {
        if (res.data.Resultcode == 0) {
          this.tableData1 = res.data.data
        }
      })
    },
    //获取付款列表
    async getOrdersByID(ordersid) {
      await this.$newsApi.order.getOrdersByID({ id: ordersid }).then(res => {
        if (res.data.Resultcode == 0) {
          this.orderssn = res.data.data.Orders_SN;
        }
      })
    },
    //获取详情商品表格内容
    getOrdersDeliveryApplyGoods() {
      this.$newsApi.getOrdersDeliveryApplyGoods({ Apply_ID: this.id }).then(res => {
        if (res.data.Resultcode == 0) {
          this.tableData = res.data.data
        }
      })
    },
    //获取地址
    getDisplayAddress() {
      getDisplayAddressStr(this.detailsInfo.Apply_Country, this.detailsInfo.Apply_State, this.detailsInfo.Apply_City, this.detailsInfo.Apply_County, (result) => {
        this.addressStr = result.resultinfo
        console.log(result)
      }, (err) => {
        console.log(err)
      })
    },
    //申请状态获取
    getOrdersDeliveryApplyValidStatus() {
      this.$newsApi.common.getOrdersDeliveryApplyValidStatus({ status: this.detailsInfo.Apply_ValidStatus }).then(res => {
        if (res.data.Resultcode == 0) {
          this.Apply_ValidStatusStr = res.data.data
        }
      })
    },
    //审核状态获取
    getOrdersBPMAuditStatus() {
      this.$newsApi.common.getOrdersBPMAuditStatus({ status: this.detailsInfo.Apply_Status }).then(res => {
        if (res.data.Resultcode == 0) {
          this.Apply_StatusStr = res.data.data
        }
      })
    },
	  goOrderdetail(OrdersID) {
		  const path = '/orderManagement/orderDetails';
		  const query = { id: OrdersID };
		  if (this.$route.path === path && this.$route.query.id == OrdersID) {
			this.onOrderdetailClose()
		
		  } else {
				this.isclose = false;
			  this.dialogVisible = false;
			  this.$router.push({ path: '/orderManagement/orderDetails', query: { id: OrdersID } });
		  }

	  },
onOrderdetailClose() {
  this.isclose = false;
  this.dialogVisible = false;
  this.$emit('handleClose', false);
},
    getOrdersDeliveryByApplyID() {
      this.$newsApi.getOrdersDeliveryByApplyID({ Apply_ID: this.detailsInfo.Apply_ID }).then(res => {
        if (res.data.Resultcode == 0) {
          if (res.data.data) {
            this.Orders_Delivery_ERPSN = res.data.data.Orders_Delivery_ERPSN
            this.Orders_Delivery_ID = res.data.data.Orders_Delivery_ID + ""
          } else {
            this.Orders_Delivery_ERPSN = "--"
          }

        }
      })
    },
    //确认提交
     async onSubmit() {
      this.json={}
       let needJson = JSON.parse(JSON.stringify(this.json));
      let amountList = JSON.parse(JSON.stringify(this.appropriationrecord))
      amountList.map(item => {
        item['Rec_Amount_' + item.Receipt_ID] = item.Receipt_ShowAmount

      })
      for (let i = 0; i < this.appropriationrecord.length; i++) {
                needJson['Rec_Amount_' + this.appropriationrecord[i].Receipt_ID] = this.appropriationrecord[i].Receipt_ShowAmount;
            }
      let params = { Apply_ID: this.id, ischeck: this.ischeck, json: JSON.stringify(needJson) }
        let loadingInstance = this.$loading(); // 显示 loading
        let res = await this.$newsApi.getOrdersDeliveryApplyBPMSendAudit(params);
        if (res.data.Resultcode == 2) {
          if (this.ischeck) {
            this.$confirm(res.data.Resultinfo, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'info'
            }).then(() => {
              this.ischeck = false
              this.onSubmit()
            }).catch(() => {
              this.$closeLoading(loadingInstance); // 关闭 loading
              this.ischeck = true
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
          }
        }
        if (res.data.Resultcode == 0 && !this.ischeck) {
          this.isSubmitDialog = false
          this.onInitData()
          this.handleClose() 
          this.$closeLoading(loadingInstance); // 关闭 loading
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.$emit('refresh-parent');
        }
    },
    onSubmitDialogClose() {
      this.isSubmitDialog = false
    },

  }
}
</script>

<style lang="scss" scoped>
$--color-primary: #4e6ef2;

/deep/.custom-label {
  width: 8vw;
}
.links {
    color: #409eff;
    cursor: pointer;
}

.hw-form-item-label{
  width: 160px !important;
}

.details-box {
  padding: 0px 20px 20px 20px;
}

.details-box-title {
  position: relative;
  padding-left: 10px;
}

.details-box-title:before {
  content: '';
  width: 4px;
  height: 16px;
  position: absolute;
  top: 0;
  left: 0px;
  background: $--color-primary;
}

.hw-form-item {
  padding: 10px 0;
  display: flex;
  align-items: center;

  &-label {
    text-align: right;
    width: 140px;
  }
}
</style>